import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content"
}
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "columns has-background-warning-light" }
const _hoisted_5 = { class: "column" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Metadata", -1)
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Name", -1)
const _hoisted_9 = { class: "columns" }
const _hoisted_10 = { class: "column is-three-quarters" }
const _hoisted_11 = { class: "column" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Prefilled Link", -1)
const _hoisted_14 = { class: "columns" }
const _hoisted_15 = { class: "column is-three-quarters" }
const _hoisted_16 = { class: "column" }
const _hoisted_17 = { class: "buttons has-addons" }
const _hoisted_18 = { class: "field" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Response Sheet", -1)
const _hoisted_20 = { class: "columns" }
const _hoisted_21 = { class: "column is-three-quarters" }
const _hoisted_22 = { class: "column" }
const _hoisted_23 = { class: "buttons has-addons" }
const _hoisted_24 = { class: "field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Voting System", -1)
const _hoisted_26 = { class: "select" }
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "field mt-5" }
const _hoisted_29 = { class: "column" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h2", null, "Tokens", -1)
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "buttons has-addons" }
const _hoisted_33 = { class: "columns" }
const _hoisted_34 = { class: "column" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h2", null, "Evaluation", -1)
const _hoisted_36 = { class: "columns" }
const _hoisted_37 = { class: "column is-one-fifth" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "column" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_vote_result_render = _resolveComponent("vote-result-render")!

  return (_ctx.vote)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", null, "Vote " + _toDisplayString(_ctx.vote.name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vote.name) = $event)),
                    type: "text",
                    class: "input"
                  }, null, 512), [
                    [_vModelText, _ctx.vote.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyName && _ctx.copyName(...args))),
                    class: "button is-link"
                  }, "Copy")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vote.prefilledLink) = $event)),
                    type: "text",
                    class: "input"
                  }, null, 512), [
                    [_vModelText, _ctx.vote.prefilledLink]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.copyPrefilledLink && _ctx.copyPrefilledLink(...args))),
                      class: "button is-link"
                    }, "Copy"),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openPrefilledLink && _ctx.openPrefilledLink(...args))),
                      class: "button is-link"
                    }, "Open")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.vote.spreadsheetLink) = $event)),
                    type: "text",
                    class: "input"
                  }, null, 512), [
                    [_vModelText, _ctx.vote.spreadsheetLink]
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.copySpreadsheetLink && _ctx.copySpreadsheetLink(...args))),
                      class: "button is-link"
                    }, "Copy"),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openSpreadsheetLink && _ctx.openSpreadsheetLink(...args))),
                      class: "button is-link"
                    }, "Open")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.vote.votingSystem) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.votingSystems, (votingSystem) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: votingSystem.id
                    }, _toDisplayString(votingSystem.name), 9, _hoisted_27))
                  }), 256))
                ], 512), [
                  [_vModelSelect, _ctx.vote.votingSystem]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveChanges && _ctx.saveChanges(...args)), ["prevent"])),
                type: "button",
                class: "button is-primary"
              }, "Save Changes")
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            (_ctx.vote.tokens.length === 0)
              ? (_openBlock(), _createBlock(_component_FileUpload, {
                  key: 0,
                  onUpload: this.uploadTokenFile
                }, null, 8, ["onUpload"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createTextVNode(_toDisplayString(_ctx.vote.tokens.length) + " tokens loaded ", 1),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("button", {
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.clearTokens && _ctx.clearTokens(...args))),
                      class: "button"
                    }, "Remove tokens")
                  ])
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("button", {
                  onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.evaluateVote && _ctx.evaluateVote(...args)), ["prevent"])),
                  type: "button",
                  class: "button is-danger"
                }, " Calculate Vote Result ")
              ]),
              _hoisted_38
            ]),
            (_ctx.results.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.results, (result) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: JSON.stringify(_ctx.results)
                  }, [
                    _createVNode(_component_vote_result_render, { result: result }, null, 8, ["result"])
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}